var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_557",
    "data-name": "Group 557",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.482,
    height: 15.482,
    viewBox: "0 0 15.482 15.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M0,0H15.482V15.482H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M8.806,1l5.3,1.178a.645.645,0,0,1,.505.63V9.25a3.87,3.87,0,0,1-1.724,3.22L8.806,15.192,4.724,12.47A3.869,3.869,0,0,1,3,9.251V2.808a.645.645,0,0,1,.505-.63Zm2.872,4.659L8.484,8.851,6.66,7.027l-.912.912,2.737,2.737L12.59,6.571Z",
    transform: "translate(-1.065 -0.355)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/securityIcon.e4db0191d3dd53ec1a6a33d8c43d386c.svg";
export { ForwardRef as ReactComponent };